import { Link } from "react-router-dom"
import textServices from "services/text-services"

export const ERRORS = [
  { code: 1112, message: 'La fotografía excede el tamaño permitido', description: '4 Mb es el limite', button: 'Volver a intentar' },
  { code: 10, message: '¡Ups! HAS INGRESADO UN CÓDIGO OTP INCORRECTO', description: 'Dele click en REENVIAR para recibir otro código e intentarlo de nuevo.', button: 'Reenviar código' },
  { code: 11, message: '¡Ups! INGRESASTE UN CÓDIGO ERRÓNEO', description: 'No te preocupes e inténtalo de nuevo.', button: <><Link to="/redeem">VOLVER A INTENTAR</Link></> },
  { code: 12, message: '¡Ups! INGRESASTE UN CÓDIGO ERRÓNEO', description: 'No te preocupes e inténtalo de nuevo.', button: <><Link to="/redeem">VOLVER A INTENTAR</Link></> },
  { code: 15, message: 'Ups, has alcanzado el máximo de canjeo en el día, vuelve mañana', description: '' },
  { code: 17, message: 'Pss, este cupón ya no puede ser usado', description: 'No te preocupes e inténtalo de nuevo', button: <><Link to="/redeem">VOLVER A INTENTAR</Link></> },
  { code: 18, message: '¡Ups! Este código ya fue utilizado antes', description: 'No te preocupes e inténtalo de nuevo', button: <><Link to="/redeem">VOLVER A INTENTAR</Link></> },
  { code: 50, message: 'Tu cuenta aún no fue validada, te hemos enviado un email para avanzar', button: 'Volver a intentar' },
  { code: "auth/wrong-password", message: 'Contraseña invalida', button: 'Volver a intentar' },
  { code: "auth/user-not-found", message: 'Usuario inexistente', button: 'Volver a intentar' },
  { code: "auth/email-already-in-use", message: 'Este mail ya se encuentra registrado en la base de datos de Heineken México', button: 'Volver a intentar' },
  { code: "auth/account-exists-with-different-credential", message: 'UPS ya ingresaste con ese correo electrónico usando otra red social', button: 'Volver a intentar' },
  { code: "auth/email-not-exist", message: 'Es necesario disponer de una cuenta con email', description: 'Intenta nuevamente con otra cuenta o red social', button: 'Volver a intentar' },
  {
    code: 51,
    message: '¡Ups! Tu cuenta de Facebook no tiene email',
    description: 'Necesitamos saber tu email para enviarte notificaciones'
  },
  { code: 58, message: 'No se ha encontrado el usuario por el código de referido', description: '', button: 'VOLVER' },
  { code: 59, message: '¡Chin! No vamos para ese destino, pero no te preocupes', description: '' },
  {
    code: 61,
    message: 'Has alcanzado el límite de cambios en tu dirección',
    description: 'Para cualquier duda ingresa:'
  },
  {
    code: 62,
    message: '¡Ups! Has ingresado la misma dirección',
    description: ''
  },
  {
    code: 63,
    message: 'La dirección ingresada ya existe en otro usuario',
    description: '',
    button: 'CORREGIR DIRECCIÓN'
  },
  {
    code: 64,
    message: '¡Oh no! El número parece incorrecto',
    description: 'Por favor ingresa un número válido. Recuerda que debe ser un número de celular.',
    button: 'CORREGIR NÚMERO DE CELULAR'
  },
  {
    code: 66,
    message: 'Es una lástima, tu cuenta ha sido bloqueada por 48 hrs. Mañana podrás intentarlo.',
    description: <>Esto es por seguridad debido a ingresos de códigos sospechosos. <br />No te apures si es un mal entendido nos pondremos en contacto contigo.</>,
    button: 'NECESITAS AYUDA?'
  },
  {
    code: 67,
    message: '¡Nos engañaste! has sido bloqueado de forma permanente',
    description: <>Al haber sido bloqueado 3 veces hemos bloqueado tu cuenta. <br />No te apures si es un mal entendido nos pondremos en contacto contigo.</>,
    button: 'NECESITAS AYUDA?'
  },
  {
    code: 68,
    message: 'EL CURP ya existe en otra cuenta',
    description: 'Por el momento no puedes utilizar este CURP dado que ya existe en otra cuenta activa.'
  },
  {
    code: 69,
    message: 'El celular ya existe en otra cuenta',
    description: 'Por el momento no puedes utilizar este celular dado que ya existe en otra cuenta activa.',
    button: 'CAMBIAR NÚMERO DE CELULAR'
  },
  { code: 71, message: 'Ups, parece que el código ingresado ha expirado', description: '', button: 'Reenviar código' },
  { code: 72, message: 'Ups, parece que el apodo ya existe', description: 'Prueba con un apodo distinto', button: 'VOLVER' },
  { code: 100, message: 'Ups, parece que hubo un problema con tu código de validación, por favor intenta nuevamente', description: 'No hemos podido validar tu correo correctamente. Prueba de nuevo', button: 'VOLVER A INTENTAR' },
  { code: 102, message: 'La cuenta ingresada es inexistente', description: 'No hemos podido validar tu correo correctamente. Prueba de nuevo', button: 'VOLVER A INTENTAR' },
  { code: 107, message: 'La cuenta de correo ya está validada', button: 'INICIAR SESIÓN' },
  { code: 150, message: '¡Chin! No vamos para ese destino, pero no te preocupes', description: '' },
  { code: 153, message: 'Es necesario completar tu dirección para poder acceder', description: 'Debemos validar correctamente tu dirección', button: 'CAMBIAR MI DIRECCIÓN' },
  { code: 251, message: '¡Chin! Nos hemos quedado sin disponibilidad por el momento', description: '' },
  { code: 252, message: '¡Chin! No vamos para ese destino, pero no te preocupes', description: '' },
  { code: 253, message: `Ups, parece que no tienes suficientes ${POINTS_NAME}`, description: '' },
  { code: 254, message: 'Pss, tienes que esperar para conseguir otro', description: '' },
  { code: 456, message: 'El código debe tener al menos 8 caracteres', description: '' },
  {
    code: 505, message: textServices.findByText('error/505/title', '¡Oh no! FALLASTE'),
    description: textServices.findByText('error/505/description', 'RECUERDA QUE PUEDES INTENTARLO NUEVAMENTE, ¡ÉCHALE GANAS!'),
    button: 'VOLVER AL HOME'
  },
  {
    code: 508,
    message: '¡Ups! Esta trivia no esta en proceso',
    description: 'Es posible que haya terminado el tiempo'
  },
  {
    code: 511,
    message: '¡Ups! Esta trivia ya tiene todos sus ganadores',
    description: 'Es posible que ya no se encuentre más disponible, por favor intenta con otra trivia más adelante.'
  },
  {
    code: 509,
    message: <>ups! HA EXPIRADO <br /> EL CÓDIGO OTP</>,
    description: <>Dele click en REENVIAR para recibir <br /> otro código e intentarlo de nuevo.</>,
    button: 'Reenviar código'
  },
  {
    code: 900,
    message: <>¡AÚN NO PUEDE<br />SUBIR SU FOTO!</>,
    description: <>Falta que termine de completar su perfil</>,
    button: '¡VAMOS A COMPLETARLO!'
  },
  {
    code: 901,
    message: '¡Gracias por escribirnos! Recibimos tu mensaje.',
    description: 'Danos un par de días para contestarte y estamos seguros que te vamos a poder ayudar. Recuerda que te llegará la respuesta por mail. ',
  },
  {
    code: 1006,
    message: <>ups! EL CÓDIGO <br /> parece inválido</>,
    description: <>Es posible que el código ingresado no exista <br /> o ya haya sido utilizado por otro usuario.</>,
  },
  {
    code: 1506,
    message: 'UPS! Parece que el tipo de archivo no es valido',
    description: 'Asegúrate de que el archivo sea una imagen de tipo png, jpeg o jpg',
  },
  { code: 99999, message: 'Ha ocurrido un error', description: '', button: <>¿ES UN ERROR?<br /> PARA CUALQUIER DUDA INGRESA AQUI</> }
]

export const prettyError = (code?: number | string) => {
  const defaultMessage = ERRORS.find((error) => error.code === 99999)?.message
  const errorMesg = ERRORS.find((error) => error.code === code)
  return errorMesg?.message ? errorMesg?.message : defaultMessage
}

export const prettyErrorDescription = (code?: number | string) => {
  const defaultMessage = ERRORS.find((error) => error.code === 99999)?.description
  const errorMesg = ERRORS.find((error) => error.code === code)
  return errorMesg?.description ? errorMesg?.description : defaultMessage
}

export const prettyErrorButton = (code?: number | string) => {
  const errorMesg = ERRORS.find((error) => error.code === code)
  return errorMesg?.button
}
